import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import kyThiService from "services/hrm/ThiCuoiKyService";

export const create = createAsyncThunk(
  "kyThiSlice/create",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await kyThiService.create(data);
      if (onSuccess) onSuccess(response.data);
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getDanhSachKyThi = createAsyncThunk(
  "kyThiSlice/danhSachKyThi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await kyThiService.getDanhSachKyThi(data);
      console.log("danhSachKyThi 1", response.data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getDanhSachKyThiViecTuTe = createAsyncThunk(
  "kyThiSlice/danhSachKyThiViecTuTe",
  async (data, { rejectWithValue }) => {
    try {
      const response = await kyThiService.getDanhSachKyThi(data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const huyNopBaiThi = createAsyncThunk(
  "kyThiSlice/huyNopBaiThi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await kyThiService.huyNopBaiThi(id);
      if (onSuccess) onSuccess(response.data);
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

// danh sách bài thi

export const getDanhSachDeThi = createAsyncThunk(
  "kyThiSlice/getDanhSachDeThi",
  async (data, { rejectWithValue }) => {
    try {
      const { type } = data;
      const response = await kyThiService.getDanhSachDeThi(type);
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createDanhSachDeThi = createAsyncThunk(
  "kyThiSlice/createDanhSachDeThi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await kyThiService.createBaiThi(data);
      if (onSuccess) onSuccess(response.data);
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const chiTietBaiThi = createAsyncThunk(
  "kyThiSlice/chiTietBaiThi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await kyThiService.chiTietBaiThi(data);
      if (onSuccess) onSuccess(response.data);
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

// bài thi đã nộp
export const getDanhSachBaiThiDaNop = createAsyncThunk(
  "kyThiSlice/getDanhSachBaiThiDaNop",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await kyThiService.danhSachBaiThiDaNop(data);
      if (onSuccess) onSuccess(response.data);
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const postChamThi = createAsyncThunk(
  "kyThiSlice/postChamThi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await kyThiService.chamThi(data);
      if (onSuccess) onSuccess(response);
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getImportByTransId = createAsyncThunk(
  "kyThiSlice/getImportByTransId",
  async (transId, { rejectWithValue }) => {
    try {
      const response = await kyThiService.getImportByTransId(transId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const importyTransId = createAsyncThunk(
  "kyThiSlice/importyTransId",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await kyThiService.importByTransId(id);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const UpdateImportSynceAsset = createAsyncThunk(
  "kyThiSlice/UpdateImportSynceAsset",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await kyThiService.importSynce(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const YeuCauPhucKhao = createAsyncThunk(
  "kyThiSlice/YeuCauPhucKhao",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await kyThiService.yeuCauPhucKhao(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const PhanHoiPhucKhao = createAsyncThunk(
  "kyThiSlice/PhanHoiPhucKhao",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await kyThiService.phanHoiPhucKhao(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getDanhSachViecTuTeDaNop = createAsyncThunk(
  "kyThiSlice/danhSachViecTuTeDaNop",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const response = await kyThiService.danhSachViecTuTeDaNop(data);
      if (onSuccess) onSuccess(response);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const chiTietBaiThiById = createAsyncThunk(
  "kyThiSlice/chiTietBaiThiById",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await kyThiService.chiTietBaiThiById(id);
      if (onSuccess) onSuccess(response.data);
      return response.data?.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  danhSachKyThi: [],
  danhSachKyThiViecTuTe: [],
  danhSachBaiThiDaNop: [],
  chiTietBaiThi: {},
  danhSachDeThi: [],
  danhSachViecTuTeDaNop: [],
};

const kyThiSlice = createSlice({
  name: "kyThiSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(create.pending, (state) => {
        state.loading = true;
      })
      .addCase(create.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(create.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getDanhSachKyThi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDanhSachKyThi.fulfilled, (state, action) => {
        state.loading = false;
        state.danhSachKyThi = action.payload || [];
      })
      .addCase(getDanhSachKyThi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getDanhSachKyThiViecTuTe.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDanhSachKyThiViecTuTe.fulfilled, (state, action) => {
        state.loading = false;
        state.danhSachKyThiViecTuTe = action.payload || [];
      })
      .addCase(getDanhSachKyThiViecTuTe.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getDanhSachDeThi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDanhSachDeThi.fulfilled, (state, action) => {
        state.loading = false;
        state.danhSachDeThi = action.payload || [];
      })
      .addCase(getDanhSachDeThi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(chiTietBaiThi.pending, (state) => {
        state.loading = true;
      })
      .addCase(chiTietBaiThi.fulfilled, (state, action) => {
        state.loading = false;
        state.chiTietBaiThi = action.payload || {};
      })
      .addCase(chiTietBaiThi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getDanhSachBaiThiDaNop.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDanhSachBaiThiDaNop.fulfilled, (state, action) => {
        state.loading = false;
        state.danhSachBaiThiDaNop = action.payload || [];
      })
      .addCase(getDanhSachBaiThiDaNop.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getDanhSachViecTuTeDaNop.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDanhSachViecTuTeDaNop.fulfilled, (state, action) => {
        state.loading = false;
        state.danhSachViecTuTeDaNop = action.payload || [];
      })
      .addCase(getDanhSachViecTuTeDaNop.rejected, (state) => {
        state.loading = false;
      })

      .addCase(chiTietBaiThiById.pending, (state) => {
        state.loading = true;
      })
      .addCase(chiTietBaiThiById.fulfilled, (state, action) => {
        state.loading = false;
        state.chiTietBaiThi = action.payload || {};
      })
      .addCase(chiTietBaiThiById.rejected, (state) => {
        state.loading = false;
      });
  },
});
// eslint-disable-next-line no-empty-pattern
export const { } = kyThiSlice.actions;

export default kyThiSlice.reducer;
